import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Opportunity() {
	return (
		<div>
			<HelmetProvider>
				<Helmet>
					<title>ESG Opportunity</title>
					<meta name="description" content="ESG Opportunity" />
					<meta
						name="keywords"
						content="ESG , Nachhaltige, Analyse, Optimierung , Feingeist, Berlin"
					/>
				</Helmet>
			</HelmetProvider>
			<div className="alt-font">
				<h2 id="opportunity">ESG Opportunity (ESG Data & AI for Impact)</h2>
				<p>
					Mit unserem Beratungsangebot "ESG Opportunity: Nachhaltige Analyse und
					Optimierung" unterstützen wir Unternehmen dabei, ihre
					Nachhaltigkeitsleistungen zu verbessern und ihren Unternehmenswert zu
					erhöhen. Wir bieten eine tiefgehende Analyse von ESG-Daten, um ein
					besseres Verständnis für die Nachhaltigkeitsleistungen und -potentiale
					eines Unternehmens zu gewinnen. Durch die Verwendung dieser Daten
					können wir gemeinsam ein individuelles Konzept für die Optimierung des
					ESG Reifegrads entwickeln, das zu einer höheren Bewertung des
					Unternehmens durch Investoren und einer höheren Wertschöpfung führt.
				</p>
				<p>
					Zusammen mit der juS.TECH AG beraten wir Sie auch bei der Konzeption
					nachhaltiger IT-Strategien und eines intelligenten ESG Management
					Systems, das die Daten effizient auswerten und nutzen kann. Hierbei
					setzen wir auf die künstliche Intelligenz, um bessere Entscheidungen
					zu treffen und individuelle Lösungen im Bereich der unternehmerischen
					Nachhaltigkeit zu entwickeln.{" "}
				</p>
				<p>
					Unser Ziel ist es, Ihnen eine umfassende Beratung zu bieten, die Ihren
					Bedürfnissen gerecht wird und Ihnen dabei hilft, Ihre
					Nachhaltigkeitsleistungen zu verbessern und Ihren Unternehmenswert zu
					erhöhen. Kontaktieren Sie uns, um mehr über unsere Dienstleistungen zu
					erfahren und Ihre Nachhaltigkeitsstrategie auf das nächste Level zu
					bringen.
				</p>
				<ul className="typeset-u-list">
					<li>Nachhaltige&nbsp;Analyse von ESG-Daten und Potentialanalysen</li>
					<li>
						Nutzung der erhobenen Daten zur Verbesserung des ESG&nbsp;Ratings,
						der Verbräuche etc.
					</li>
					<li>Wertschöpfung und Optimierung des ESG Reifegrads</li>
					<li>Erhöhung des Unternehmenswerts</li>
					<li>Konzeption&nbsp;und Beratung nachhaltiger IT-Strategien</li>
					<li>Konzeption&nbsp;eines intelligenten ESG Management Systems</li>
					<li>
						Sustainable&nbsp;Solutions: Individuelle Lösungen im Bereich der
						Optimierung der&nbsp;unternehmerischen Nachhaltigkeit
					</li>
				</ul>
			</div>
		</div>
	);
}
